import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "./app/providers/ThemeProvider";
import { AuthProvider } from "./app/providers/AuthProvider";
import App from "./App";
import "./theme/tokens.css";
import { getEnv } from "./app/config/env";
import { getCanonicalRedirectTarget, getConfiguredCanonicalOrigin, getConfiguredRedirectOrigins } from "./app/config/canonicalOrigin";

const env = getEnv();
const canonicalRedirectTarget = getCanonicalRedirectTarget(
  window.location.href,
  getConfiguredCanonicalOrigin(env.canonicalOrigin),
  getConfiguredRedirectOrigins(env.canonicalRedirectOrigins),
);

if (canonicalRedirectTarget) {
  window.location.replace(canonicalRedirectTarget);
} else {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
}
